module.exports = __webpack_public_path__ + "static/media/intro-photowall-35.eb483acd.jpg";